import clsx from 'clsx'
import { HTMLProps } from 'react'

export interface PropsCustomBadge extends HTMLProps<HTMLDivElement> {
  color?: 'default' | 'blue' | 'purple' | 'yellow' | 'green' | 'red' | 'orange'
}

const CustomBadge = ({ children, color = 'default' }: PropsCustomBadge) => {
  return (
    <div
      className={clsx(
        'whitespace-nowrap inline-flex rounded-full border border-transparent text-xs font-medium px-2.5 py-1',
        {
          'bg-gray-10 text-black': color === 'default',
          'bg-blue-20 text-blue-80': color === 'blue',
          'bg-purple-20 text-purple-80': color === 'purple',
          'bg-yellow-20 text-yellow-80': color === 'yellow',
          'bg-green-20 text-green-80': color === 'green',
          'bg-red-20 text-red-80': color === 'red',
          'bg-orange-20 text-orange-80': color === 'orange',
        }
      )}
    >
      {children}
    </div>
  )
}

export default CustomBadge
